import { Navigate } from 'react-router-dom'
import {
  JURISDICTION_RULES_TAB_SCOPE,
  LOCATION_FEATURES_APPLET_SCOPES,
  READ_LOCATION_MANAGEMENT_SETTINGS_SCOPES,
  READ_LOCATION_MONITORING_SCOPE,
  READ_LOCATIONS_SCOPE,
  READ_PERMITS_SCOPE,
  READ_PERMITTING_COMMENTS_SCOPE
} from '../../constants'
import { AppRoute } from '../../auth/routeAuth'
import { LocationManagementPage } from './LocationManagementPage'
import { LocationSettingsTab } from './LocationManagementPage/LocationSettingsTab'
import { PracticeModeTab } from './LocationManagementPage/PracticeModeTab'
import { PermitsTab } from './LocationManagementPage/PermitsTab'
import { JurisdictionDetailsTab } from './LocationManagementPage/JurisdictionDetailsTab'
import { ChangeLogTab } from './LocationManagementPage/ChangeLogTab'
import { addressValidationPaths } from '../address-scheduler/addressValidationPaths'
import { AddressForm } from './LocationManagementPage/LocationSettingsTab/AddressForm'
import { AddressChangeRedirect } from './LocationManagementPage/LocationSettingsTab/AddressChangeRedirect'
import { SaveAddress } from './LocationManagementPage/LocationSettingsTab/SaveAddress'
import { AddressValidationResults } from './LocationManagementPage/LocationSettingsTab/AddressValidationResults'
import { AddressConfirmation as AddressSchedulerConfirmation } from '../address-scheduler/AddressConfirmationPage/AddressConfirmation'
import { FeatureViewerTab } from './LocationManagementPage/FeatureViewerTab'

export const locationManagementRoutes: AppRoute[] = [
  {
    path: '',
    element: <LocationManagementPage />,
    auth: { scopes: [READ_LOCATIONS_SCOPE], mode: 'all' },
    children: [
      {
        path: 'settings',
        children: [
          {
            path: '',
            element: <LocationSettingsTab />,
            auth: { scopes: READ_LOCATION_MANAGEMENT_SETTINGS_SCOPES, mode: 'any' }
          },
          {
            path: addressValidationPaths.overview,
            element: <AddressChangeRedirect />,
            auth: { scopes: READ_LOCATION_MANAGEMENT_SETTINGS_SCOPES, mode: 'any' },
            children: [
              // these routes reuse the address scheduler components and need to define the same relative paths for it to work
              { path: '', element: <Navigate to={'..'} replace={true} /> },
              { path: addressValidationPaths.addressForm, element: <AddressForm /> },
              { path: addressValidationPaths.validationResults, element: <AddressValidationResults /> },
              { path: addressValidationPaths.confirmation, element: <AddressSchedulerConfirmation /> },
              { path: addressValidationPaths.timeZone, element: <SaveAddress /> },
              { path: addressValidationPaths.datePicker, element: <SaveAddress /> }
            ]
          }
        ]
      },
      {
        path: 'practice-mode',
        element: <PracticeModeTab />,
        auth: { scopes: [READ_LOCATION_MONITORING_SCOPE], mode: 'all' }
      },
      {
        path: 'permits',
        element: <PermitsTab />,
        auth: { scopes: [READ_PERMITS_SCOPE, READ_PERMITTING_COMMENTS_SCOPE], mode: 'any' }
      },
      {
        path: 'jurisdiction-details',
        element: <JurisdictionDetailsTab />,
        auth: { scopes: [JURISDICTION_RULES_TAB_SCOPE], mode: 'all' }
      },
      {
        path: 'change-log',
        element: <ChangeLogTab />,
        auth: { scopes: [READ_LOCATIONS_SCOPE], mode: 'all' }
      },
      {
        path: 'location-features',
        element: <FeatureViewerTab />,
        auth: { scopes: LOCATION_FEATURES_APPLET_SCOPES, mode: 'all' }
      }
    ]
  }
]
